import { render, staticRenderFns } from "./CustomerEditTreatments.vue?vue&type=template&id=e2856268&scoped=true"
import script from "./CustomerEditTreatments.vue?vue&type=script&lang=js"
export * from "./CustomerEditTreatments.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditTreatments.vue?vue&type=style&index=0&id=e2856268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2856268",
  null
  
)

export default component.exports